<template>
  <v-bottom-sheet v-model="internalDialog" inset class="mx-auto" style="width:100%; max-width:400px">
    <v-card class="pa-4 text-center text-wrap" style="border-top-left-radius:20px; border-top-right-radius:20px;">
          <div class="flex flex-col items-center gap-6">
            <div class="flex max-w-[480px] flex-col items-center gap-2">
              <p class="text-[#211708] text-lg font-bold leading-tight tracking-[-0.015em] max-w-[480px] text-center">Yon espas kote imajinasyon nou san limit</p>
              <p class="text-[#211708] text-sm font-normal leading-normal max-w-[480px] text-center">Ensri gratis</p>
            </div>
          </div>
  <div class="flex justify-center">
          <div class="flex flex-1 gap-3 max-w-[480px] flex-col items-stretch px-4 py-3">
            <button @click="handleSignIn('google')"
              class="flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center
               overflow-hidden rounded-full h-10 px-4 bg-[#FF6F00] text-[#211708] text-sm font-bold 
               leading-normal tracking-[0.015em] w-full"
            >
              <span class="truncate">Kontinye ak Google</span>
            </button>
            <button @click="handleSignIn('email')"
              class="flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-full h-10 px-4 bg-[#f6ebda] text-[#211708] text-sm font-bold leading-normal tracking-[0.015em] w-full"
            >
              <span class="truncate">Imel ak modpas</span>
            </button>
          </div>
        </div>

      <!-- Checkbox Politique + Conditions -->
      <div class="text-center d-flex flex-row">
        <v-checkbox v-model="check" class="mb-3" color="amber-darken-4">
        </v-checkbox>
        <div class="text-base font-normal leading-normal">
          Mwen aksepte
          <span class="text-none font-weight-bold text-[#211708] text-base font-normal leading-normal" @click="navigateTo('/PolitiqueUserPage')">Politik
            Konfidansyalite</span>
          ak
          <span class="text-none font-weight-bold text-[#211708] text-base font-normal leading-normal"
            @click="navigateTo('/ConditionUserPage')">Kondisyon itilizasyon</span>
          Dous Literè.
        </div>
      </div>

      <!-- Message d'erreur si la case n'est pas cochée -->
      <span v-if="showError" class="text-danger text-wrap text-center">
        Ou dwe aksepte politik Konfidansyalite ak kondisyon itilizasyon Dous Literè pou w enskri oubyen konekte
      </span>

    </v-card>
  </v-bottom-sheet>

  <v-dialog v-model="signWithEmail" persistent fullscreen scrollable>
    <v-card style="width:100%; height:100vh" max-width="344">

      <!-- Close Button -->
      <div class="d-flex justify-start ml-4 mt-1 mb-1">
        <v-btn icon @click="closeDialog" variant="text">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
<v-card-text style="height: 100vh;">
      <!-- Formulaire de Connexion -->
      <v-form v-if="isLogin" @submit.prevent="login" class="d-flex  flex-column mx-auto p-2" style=";width:100%; max-width: 400px;">

          <h2 class="text-[#211108] tracking-light text-[28px] font-bold leading-tight px-4 text-center pb-3 pt-5">Koneksyon</h2>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-0 w-full ma-0 pa-0">

           <div class="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
          <label class="flex flex-col min-w-40 flex-1">
            <p class="text-[#211108] text-base font-medium leading-normal pb-2">Imel*</p>
            <div class="flex w-full flex-1 items-stretch rounded-xl">
              <input
                placeholder="Imel*"
                class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-l-xl  text-[#211108] focus:outline-0 focus:ring-0 border-[#f6e8da] bg-[#f6e8da] focus:border-[#f6e8da] h-14 placeholder:text-[#b45c2d] p-[15px] rounded-r-none border-r-0 pr-2 text-base font-normal leading-normal"
                 v-model="email"
          type="email"
          autocomplete="email"
          required
              />

                <!-- CLEARABLE ICON -->
        <span
          v-if="email"
          @click="email = ''"
          class="flex items-center px-3 cursor-pointer text-[#b45c2d] border-[#f6e8da] bg-[#f6e8da] border-l-0 rounded-r-l"
        >
          ✖
        </span>

              <div
                class="text-[#b45c2d] flex border-[#f6e8da] bg-[#f6e8da] items-center justify-center pr-[15px] rounded-r-xl border-l-0"
                data-icon="EnvelopeOpen"
                data-size="24px"
                data-weight="regular"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                  <path
                    d="M228.44,89.34l-96-64a8,8,0,0,0-8.88,0l-96,64A8,8,0,0,0,24,96V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V96A8,8,0,0,0,228.44,89.34ZM96.72,152,40,192V111.53Zm16.37,8h29.82l56.63,40H56.46Zm46.19-8L216,111.53V192ZM128,41.61l81.91,54.61-67,47.78H113.11l-67-47.78Z"
                  ></path>
                </svg>
              </div>
            </div>
          </label>
        </div>

 <div class="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
    <label class="flex flex-col min-w-40 flex-1">
      <p class="text-[#211108] text-base font-medium leading-normal pb-2">Modpas*</p>
      <div class="flex w-full items-stretch rounded-xl">
        <!-- INPUT MOT DE PASSE -->
        <input
          :type="visible ? 'text' : 'password'"
          v-model="password"
          autocomplete="current-password"
          required
          placeholder="Modpas*"
          class="form-input flex w-full min-w-0 flex-1 rounded-l-xl  resize-none overflow-hidden border-[#f6e8da] bg-[#f6e8da] text-[#211108] placeholder:text-[#b45c2d] h-14 px-4 text-base font-normal leading-normal focus:outline-0 focus:ring-0 focus:border-[#f6e8da] border-r-0 rounded-r-none"
        />

        <!-- BOUTON CLEAR -->
        <span
          v-if="password"
          @click="password = ''"
          class="flex items-center px-3 cursor-pointer text-[#b45c2d] border-[#f0d2c2] bg-[#f6e8da] border-l-0"
        >
          ✖
        </span>

        <!-- BOUTON VISIBILITÉ -->
        <button
          type="button"
          @click="visible = !visible"
          class="text-[#b45c2d] flex border-[#f0d2c2] bg-[#f6e8da] items-center justify-center px-3 rounded-r-xl border-l-0"
        >
          <svg
            v-if="visible"
            class="text-[#b45c2d]"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            fill="currentColor"
            viewBox="0 0 256 256"
          >
            <!-- œil FERMÉ -->
            <path
              d="M216.49,200.49a8,8,0,0,1-11.32,11.32l-23.8-23.79A127.28,127.28,0,0,1,128,208c-35.93,0-67.63-13.27-92.73-38.36a135.4,135.4,0,0,1-24.5-33.61,15.89,15.89,0,0,1,0-14.06A136.88,136.88,0,0,1,43,88.4L23.51,68.91A8,8,0,0,1,34.83,57.59ZM94.91,128a33.06,33.06,0,0,0,33.09,33.09,32.92,32.92,0,0,0,20.09-6.82l-46.36-46.36A32.92,32.92,0,0,0,94.91,128Zm130.42-4.08a135.4,135.4,0,0,1-24.5,33.61,130.11,130.11,0,0,1-24.39,19.05L176,161.56a57,57,0,0,0-65.56-65.56L94.42,76.37A129.08,129.08,0,0,1,128,72c35.93,0,67.63,13.27,92.73,38.36A15.89,15.89,0,0,1,225.33,123.92Z"
            />
          </svg>
          <svg
            v-else
            class="text-[#b45c2d]"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            fill="currentColor"
            viewBox="0 0 256 256"
          >
            <!-- œil OUVERT -->
            <path
              d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Z"
            />
          </svg>
        </button>
      </div>
    </label>
  </div>

   <p v-if="errMsg" class="text-danger text-center text-wrap ma-2">{{ errMsg }}</p>
        <div class="flex px-4 py-3">
          <button @click="login"
            class="flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-full h-12 px-5 flex-1 bg-[#FF6F00] text-[#fbf3ef] text-base font-bold leading-normal tracking-[0.015em]"
          >
            <span class="truncate font-weight-bold text-black">Konekte</span>
          </button>
        </div>
        <p @click="navigateTo('/ForgotPasswordPage')" class="text-[#b45c2d] text-sm font-normal leading-normal pb-3 pt-1 px-4 text-center underline">Ou bliye modpas ou? Klike la</p>
        <div class="flex px-4 py-3">
          <button @click="navigateTo('/ForgotPasswordPage')"
            class="flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-full h-12 px-5 flex-1 bg-[#f6e8da] text-[#211108] text-base font-bold leading-normal tracking-[0.015em]"
          >
            <span class="truncate">Nouvo Modpas</span>
          </button>
        </div>
        <p @click="switchToRegister"  class="text-[#b45c2d] text-sm font-normal leading-normal pb-3 pt-1 px-4 text-center underline">Ou poko enskri? Klike la</p>
        <div class="flex px-4 py-3">
          <button
            class="flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-full h-12 px-5 flex-1 bg-transparent text-[#211108] text-base font-bold leading-normal tracking-[0.015em]"
          >
            <span @click="switchToRegister" class="truncate">Enskri</span>
          </button>
        </div>
      </div>
      </v-form>

      <!-- Formulaire d'Inscription -->
         <v-form v-if="!isLogin" @submit.prevent="register" class="d-flex mt-0 flex-column mx-auto p-2" style="width:100%; max-width: 400px;">

          <h2 class="text-[#211108] tracking-light text-[28px] font-bold leading-tight px-4 text-center pb-3 pt-0">Enskripsyon</h2>
  <!-- Champs en deux colonnes sur grand écran -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-0 w-full ma-0 pa-0">
<!--Siyati-->
          <div class="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
          <label class="flex flex-col min-w-40 flex-1">
            <p class="text-[#211108] text-base font-medium leading-normal pb-2">Siyati*</p>
            <div class="flex w-full flex-1 items-stretch rounded-xl">
              <input
                placeholder="Siyati*"
                class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-l-xl  text-[#211108] focus:outline-0 focus:ring-0 border-[#f6e8da] bg-[#f6e8da] focus:border-[#f6e8da] h-14 placeholder:text-[#b45c2d] p-[15px] rounded-r-none border-r-0 pr-2 text-base font-normal leading-normal"
                 v-model="siyati"
          type="text"
          autocomplete="text"
          required
              />

                <!-- CLEARABLE ICON -->
        <span
          v-if="siyati"
          @click="siyati = ''"
          class="flex items-center px-3 cursor-pointer text-[#b45c2d] border-[#f6e8da] bg-[#f6e8da] border-l-0 rounded-r-l"
        >
          ✖
        </span>

            <div
  class="text-[#b45c2d] flex border-[#f6e8da] bg-[#f6e8da] items-center justify-center pr-[15px] rounded-r-xl border-l-0"
  data-icon="Account"
  data-size="24px"
  data-weight="regular"
>
  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
    <path
      d="M128,24A56,56,0,1,0,184,80,56.06,56.06,0,0,0,128,24Zm0,96a40,40,0,1,1,40-40A40,40,0,0,1,128,120Zm77.18,33.37a103.76,103.76,0,0,0-154.36,0A55.75,55.75,0,0,0,24,200a8,8,0,0,0,16,0,40,40,0,0,1,40-40H176a40,40,0,0,1,40,40,8,8,0,0,0,16,0A55.75,55.75,0,0,0,205.18,153.37Z"
    />
  </svg>
</div>
            </div>
          </label>
        </div>
        <!--Non-->
          <div class="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
          <label class="flex flex-col min-w-40 flex-1">
            <p class="text-[#211108] text-base font-medium leading-normal pb-2">Non*</p>
            <div class="flex w-full flex-1 items-stretch rounded-xl">
              <input
                placeholder="Non*"
                class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-l-xl  text-[#211108] focus:outline-0 focus:ring-0 border-[#f6e8da] bg-[#f6e8da] focus:border-[#f6e8da] h-14 placeholder:text-[#b45c2d] p-[15px] rounded-r-none border-r-0 pr-2 text-base font-normal leading-normal"
                 v-model="non"
          type="text"
          autocomplete="text"
          required
              />

                <!-- CLEARABLE ICON -->
        <span
          v-if="non"
          @click="non = ''"
          class="flex items-center px-3 cursor-pointer text-[#b45c2d] border-[#f6e8da] bg-[#f6e8da] border-l-0 rounded-r-l"
        >
          ✖
        </span>

            <div
  class="text-[#b45c2d] flex border-[#f6e8da] bg-[#f6e8da] items-center justify-center pr-[15px] rounded-r-xl border-l-0"
  data-icon="Account"
  data-size="24px"
  data-weight="regular"
>
  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
    <path
      d="M128,24A56,56,0,1,0,184,80,56.06,56.06,0,0,0,128,24Zm0,96a40,40,0,1,1,40-40A40,40,0,0,1,128,120Zm77.18,33.37a103.76,103.76,0,0,0-154.36,0A55.75,55.75,0,0,0,24,200a8,8,0,0,0,16,0,40,40,0,0,1,40-40H176a40,40,0,0,1,40,40,8,8,0,0,0,16,0A55.75,55.75,0,0,0,205.18,153.37Z"
    />
  </svg>
</div>
            </div>
          </label>
        </div>
        <!--Imel-->
           <div class="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
          <label class="flex flex-col min-w-40 flex-1">
            <p class="text-[#211108] text-base font-medium leading-normal pb-2">Imel*</p>
            <div class="flex w-full flex-1 items-stretch rounded-xl">
              <input
                placeholder="Imel*"
                class="form-input flex w-full min-w-0 flex-1 resize-none overflow-hidden rounded-l-xl  text-[#211108] focus:outline-0 focus:ring-0 border-[#f6e8da] bg-[#f6e8da] focus:border-[#f6e8da] h-14 placeholder:text-[#b45c2d] p-[15px] rounded-r-none border-r-0 pr-2 text-base font-normal leading-normal"
                 v-model="email"
          type="email"
          autocomplete="email"
          required
              />

                <!-- CLEARABLE ICON -->
        <span
          v-if="email"
          @click="email = ''"
          class="flex items-center px-3 cursor-pointer text-[#b45c2d] border-[#f6e8da] bg-[#f6e8da] border-l-0 rounded-r-l"
        >
          ✖
        </span>

              <div
                class="text-[#b45c2d] flex border-[#f6e8da] bg-[#f6e8da] items-center justify-center pr-[15px] rounded-r-xl border-l-0"
                data-icon="EnvelopeOpen"
                data-size="24px"
                data-weight="regular"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" fill="currentColor" viewBox="0 0 256 256">
                  <path
                    d="M228.44,89.34l-96-64a8,8,0,0,0-8.88,0l-96,64A8,8,0,0,0,24,96V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V96A8,8,0,0,0,228.44,89.34ZM96.72,152,40,192V111.53Zm16.37,8h29.82l56.63,40H56.46Zm46.19-8L216,111.53V192ZM128,41.61l81.91,54.61-67,47.78H113.11l-67-47.78Z"
                  ></path>
                </svg>
              </div>
            </div>
          </label>
        </div>
<!--Password-->
 <div class="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
    <label class="flex flex-col min-w-40 flex-1">
      <p class="text-[#211108] text-base font-medium leading-normal pb-2">Modpas*</p>
      <div class="flex w-full items-stretch rounded-xl">
        <!-- INPUT MOT DE PASSE -->
        <input
          :type="visible ? 'text' : 'password'"
          v-model="password"
          autocomplete="current-password"
          required
          placeholder="Modpas*"
          class="form-input flex w-full min-w-0 flex-1 rounded-l-xl  resize-none overflow-hidden border-[#f6e8da] bg-[#f6e8da] text-[#211108] placeholder:text-[#b45c2d] h-14 px-4 text-base font-normal leading-normal focus:outline-0 focus:ring-0 focus:border-[#f6e8da] border-r-0 rounded-r-none"
        />

        <!-- BOUTON CLEAR -->
        <span
          v-if="password"
          @click="password = ''"
          class="flex items-center px-3 cursor-pointer text-[#b45c2d] border-[#f0d2c2] bg-[#f6e8da] border-l-0"
        >
          ✖
        </span>

        <!-- BOUTON VISIBILITÉ -->
        <button
          type="button"
          @click="visible = !visible"
          class="text-[#b45c2d] flex border-[#f0d2c2] bg-[#f6e8da] items-center justify-center px-3 rounded-r-xl border-l-0"
        >
          <svg
            v-if="visible"
            class="text-[#b45c2d]"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            fill="currentColor"
            viewBox="0 0 256 256"
          >
            <!-- œil FERMÉ -->
            <path
              d="M216.49,200.49a8,8,0,0,1-11.32,11.32l-23.8-23.79A127.28,127.28,0,0,1,128,208c-35.93,0-67.63-13.27-92.73-38.36a135.4,135.4,0,0,1-24.5-33.61,15.89,15.89,0,0,1,0-14.06A136.88,136.88,0,0,1,43,88.4L23.51,68.91A8,8,0,0,1,34.83,57.59ZM94.91,128a33.06,33.06,0,0,0,33.09,33.09,32.92,32.92,0,0,0,20.09-6.82l-46.36-46.36A32.92,32.92,0,0,0,94.91,128Zm130.42-4.08a135.4,135.4,0,0,1-24.5,33.61,130.11,130.11,0,0,1-24.39,19.05L176,161.56a57,57,0,0,0-65.56-65.56L94.42,76.37A129.08,129.08,0,0,1,128,72c35.93,0,67.63,13.27,92.73,38.36A15.89,15.89,0,0,1,225.33,123.92Z"
            />
          </svg>
          <svg
            v-else
            class="text-[#b45c2d]"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            fill="currentColor"
            viewBox="0 0 256 256"
          >
            <!-- œil OUVERT -->
            <path
              d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Z"
            />
          </svg>
        </button>
      </div>
    </label>
  </div>
<!--Confirm Password-->
  <div class="flex max-w-[480px] flex-wrap items-end gap-4 px-4 py-3">
    <label class="flex flex-col min-w-40 flex-1">
      <p class="text-[#211108] text-base font-medium leading-normal pb-2">Konfime modpas*</p>
      <div class="flex w-full items-stretch rounded-xl">
        <!-- INPUT MOT DE PASSE -->
        <input
          :type="visible ? 'text' : 'password'"
          v-model="confirmPassword"
          autocomplete="current-password"
          required
          placeholder="Konfime modpas*"
          class="form-input flex w-full min-w-0 flex-1 rounded-l-xl  resize-none overflow-hidden border-[#f6e8da] bg-[#f6e8da] text-[#211108] placeholder:text-[#b45c2d] h-14 px-4 text-base font-normal leading-normal focus:outline-0 focus:ring-0 focus:border-[#f6e8da] border-r-0 rounded-r-none"
        />

        <!-- BOUTON CLEAR -->
        <span
          v-if="confirmPassword"
          @click="confirmPassword = ''"
          class="flex items-center px-3 cursor-pointer text-[#b45c2d] border-[#f0d2c2] bg-[#f6e8da] border-l-0"
        >
          ✖
        </span>

        <!-- BOUTON VISIBILITÉ -->
        <button
          type="button"
          @click="visible = !visible"
          class="text-[#b45c2d] flex border-[#f0d2c2] bg-[#f6e8da] items-center justify-center px-3 rounded-r-xl border-l-0"
        >
          <svg
            v-if="visible"
            class="text-[#b45c2d]"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            fill="currentColor"
            viewBox="0 0 256 256"
          >
            <!-- œil FERMÉ -->
            <path
              d="M216.49,200.49a8,8,0,0,1-11.32,11.32l-23.8-23.79A127.28,127.28,0,0,1,128,208c-35.93,0-67.63-13.27-92.73-38.36a135.4,135.4,0,0,1-24.5-33.61,15.89,15.89,0,0,1,0-14.06A136.88,136.88,0,0,1,43,88.4L23.51,68.91A8,8,0,0,1,34.83,57.59ZM94.91,128a33.06,33.06,0,0,0,33.09,33.09,32.92,32.92,0,0,0,20.09-6.82l-46.36-46.36A32.92,32.92,0,0,0,94.91,128Zm130.42-4.08a135.4,135.4,0,0,1-24.5,33.61,130.11,130.11,0,0,1-24.39,19.05L176,161.56a57,57,0,0,0-65.56-65.56L94.42,76.37A129.08,129.08,0,0,1,128,72c35.93,0,67.63,13.27,92.73,38.36A15.89,15.89,0,0,1,225.33,123.92Z"
            />
          </svg>
          <svg
            v-else
            class="text-[#b45c2d]"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            fill="currentColor"
            viewBox="0 0 256 256"
          >
            <!-- œil OUVERT -->
            <path
              d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Z"
            />
          </svg>
        </button>
      </div>
    </label>
  </div>

    <p v-if="registrationMessage" class="registration-message text-danger text-center">{{ registrationMessage }}
          </p>
        <div class="flex px-4 py-3">
          <button @click="register"
            class="flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-full h-12 px-5 flex-1 bg-[#FF6F00] text-[#fbf3ef] text-base font-bold leading-normal tracking-[0.015em]"
          >
            <span class="truncate font-weight-bold text-black">Enskri</span>
          </button>
        </div>
        <p class="text-[#b45c2d] text-sm font-normal leading-normal pb-3 pt-1 px-4 text-center">Ou enskri deja?</p>
        <div class="flex px-4 py-3">
          <button @click="switchToLogin"
            class="flex min-w-[84px] max-w-[480px] cursor-pointer items-center justify-center overflow-hidden rounded-full h-12 px-5 flex-1 bg-[#f6e8da] text-[#211108] text-base font-bold leading-normal tracking-[0.015em]"
          >
            <span class="truncate">Konekte</span>
          </button>
        </div>
      </div>
      </v-form>
</v-card-text>

    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from "vue";
// import { Plugins } from '@capacitor/core';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { Capacitor } from '@capacitor/core';
// import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import {
  getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithCredential
} from "firebase/auth";
import { useRouter } from 'vue-router';
import { defineProps, defineEmits } from 'vue';
import { db } from "@/main"; // Importez `db` depuis le fichier main.js

import {collection, setDoc, doc, serverTimestamp, getDoc, updateDoc, where, getDocs, query } from 'firebase/firestore';

// Props et évenements
const props = defineProps({
  dialog: {
    type: Boolean,
    required: true
  },
   dialog2: {
    type: Boolean,
   required: false, // Changez en 'false' si elle n'est pas toujours nécessaire
    default: false // Ajoutez une valeur par défaut pour éviter l'erreur
  }
});
const emit = defineEmits(['update:dialog', 'update:dialog2']);

// Variables d'état
const email = ref("");
const password = ref("");
const confirmPassword = ref("");
const siyati = ref("");
const non = ref("");
const errMsg = ref("");
const registrationMessage = ref("");
const visible = ref(false);
const internalDialog = ref(props.dialog);
const signWithEmail = ref(props.dialog2);
const isLogin = ref(true);
const router = useRouter();
const check= ref(false);
const showError= ref(false);

 const handleSignIn = (method) => {
  if (!check.value) {
    showError.value = true; // Afficher l'erreur si la case n'est pas cochée
    return;
  }

  showError.value = false; // Cacher l'erreur si la case est cochée

  if (method === "google") {
    signInWithGoogle(); // Appel de la fonction Google
  } else if (method === "email") {
    signWithEmail.value = true; // Activer la connexion par email
  }
};

// Règles de validation
const rules = {
  required: value => !!value || 'Chan sa yo pa dwe vid',
  min: (v) => v.length >= 8 || 'Modpas la dwe gen omwen 8 karaktè.',
  emailMatch: () => 'Imel ak modpas ou antre yo pa matche.',
};

// Watchers
watch(() => props.dialog, (val) => {
  internalDialog.value = val;
});
watch(internalDialog, (val) => {
  emit('update:dialog', val);
});

watch(() => props.dialog2, (val) => {
  signWithEmail.value = val;
});
watch(signWithEmail, (val) => {
  emit('update:dialog2', val);
});
// Méthodes
const closeDialog = () => {
  email.value = ''; // Cacher l'erreur si la case est cochée
  password.value = ''; // Cacher l'erreur si la case est cochée
  siyati.value = ''; // Cacher l'erreur si la case est cochée
  non.value = ''; // Cacher l'erreur si la case est cochée
  confirmPassword.value = ''; // Cacher l'erreur si la case est cochée
  signWithEmail.value = false;
  internalDialog.value = false;
};

// Fonction pour basculer entre Konekte et Enskri
const switchToLogin = () => {
  isLogin.value = true;
};
const switchToRegister = () => {
  isLogin.value = false;
};

const login = async () => {
  try {
    // Connexion à Firebase Auth
    const auth = getAuth();
    const result = await signInWithEmailAndPassword(auth, email.value, password.value);
    const user = result.user;

    // console.log('Utilisateur connecté:', user);

    // Vérification ou création du document utilisateur
    const userDocRef = doc(collection(db, "users"), user.uid);
    const userDoc = await getDoc(userDocRef);

    if (userDoc.exists()) {
      await updateDoc(userDocRef, {
        lastLogin: serverTimestamp(),
        isOnline: true,
      });
    }
    // Réinitialiser les valeurs de email et password
    email.value = '';
    password.value = '';
    // Fermer le dialogue interne et rediriger
    // internalDialog.value = false;
    signWithEmail.value = false;
    internalDialog.value = false;
    router.push('/HomePage');
  } catch (error) {
    // Gestion des erreurs
    switch (error.code) {
      case "auth/invalid-email":
        errMsg.value = "Imel ou pa bon/ okenn chan pa ka vid";
        break;
      case "auth/user-not-found":
        errMsg.value = "Nou pa gen kont ak imel sa a.";
        break;
      case "auth/wrong-password":
        errMsg.value = "Modpas la pa bon/ okenn chan pa ka vid";
        break;
      default:
        errMsg.value = "Imel ou oubyen modpas ou pa bon/ okenn chan pa ka vid";
        break;
    }
  }
};
const getNonFromEmail = (email) => {
  const prefix = email.split("@")[0];
  const parts = prefix.split(".");

  if (parts.length > 1) {
    return {
      firstName: parts[0],
      lastName: parts[1]
    };
  } else {
    return {
      firstName: prefix,
      lastName: `${Math.floor(Math.random() * 10)}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${Math.floor(Math.random() * 10)}`,
    };
  }
};

// Fonction pour sauvegarder les données utilisateur dans Firestore
const saveUserToFirestore = async (user) => {
  const userDocRef = doc(collection(db, "users"), user.uid);

  // Récupérer le document utilisateur
  const userDoc = await getDoc(userDocRef);

  // Si l'utilisateur n'existe pas, on le crée
  if (!userDoc.exists()) {
    const { firstName, lastName } = getNonFromEmail(user.email);

    // Créer un nouveau document avec les données de l'utilisateur
    await setDoc(userDocRef, {
      userId: user.uid,
      imel: user.email,
      created: serverTimestamp(),
      dateInscription: serverTimestamp(),
      lastLogin: serverTimestamp(),
      non: firstName,
      siyati: lastName,
      photoURL: user.photoURL || '',
      subscribedToAnnLi: false,
      notYet: true,
      translator: false,
      writer: false,
      admin: false,
      demandeResiliation: false,
      resiliationReasonWhy: "",
      credit: 5,
      allValidCorrections: 0,
      forLevelUser: 0,
      subscribedToWriters: [],
      usersSubscribedToMe: [],
      newUser: true,
      demandeSubscription: false,
      understoodValidation: false,
      understoodRead: false,
      understoodClassification: false,
      firstWinner: false,
      secondWinner: false,
      thirdWinner: false,
      nonValid: false,
      siyatiValid: false,
      imelValid: false,
      updateApp: true,
      updateAppMobile: false,
      authorizedCamera: false,
      prime: false,
      fb: '',
      tk: '',
      x: '',
      yt: '',
      ig: '',
      shareEmailToReaders: 'non',
      isOnline: true,
      notificationAccepted: false,
      country: '',
      age: '',
      cible: '+18',
      shareLibrary: false,
      socialMedia: false,
      isAddedToList: false,
    });
  } else {
    // Si l'utilisateur existe déjà, on met à jour seulement les champs nécessaires
    await updateDoc(userDocRef, {
      lastLogin: serverTimestamp(),
      isOnline: true,
    });
  }
};

const signInWithGoogle = async () => {
  const auth = getAuth();

  try {
    let user;
    if (Capacitor.isNativePlatform()) {
      const googleUser = await GoogleAuth.signIn();
      const idToken = googleUser.authentication.idToken;
      const credential = GoogleAuthProvider.credential(idToken);
      const result = await signInWithCredential(auth, credential);
      user = result.user;
    } else {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      user = result.user;
    }

    await saveUserToFirestore(user);
    // signWithEmail.value = false;
    internalDialog.value = false;
    signWithEmail.value = false;

    router.push({ path: '/HomePage' });
    internalDialog.value = false;
    signWithEmail.value = false;

  } catch (error) {
    // console.error("Erreur lors de l'authentification Google :", error);
    // alert(error.message || "Une erreur s'est produite lors de la connexion.");
  }
};


// Fonction d'inscription avec email et password
const register = async () => {
  // Vérification des règles de mot de passe
  if (!rules.required(password.value)) {
    registrationMessage.value = rules.required(password.value);
    return;
  }
  if (!rules.min(password.value)) {
    registrationMessage.value = rules.min(password.value);
    return;
  }

  if (password.value !== confirmPassword.value) {
    registrationMessage.value = "Modpas yo pa menm";
    return;
  }

  try {

    // Vérification si l'e-mail est déjà utilisé
    const userCollectionRef = collection(db, 'users');
    const emailQuery = query(userCollectionRef, where("imel", "==", email.value));
    const emailSnapshot = await getDocs(emailQuery);

    if (!emailSnapshot.empty) {
      registrationMessage.value = "Imel sa a deja egziste nan sistèm nan.";
      return;
    }

    // Si l'e-mail n'existe pas, créer l'utilisateur
    const auth = getAuth();
    const userCredential = await createUserWithEmailAndPassword(auth, email.value, password.value);
    const user = userCredential.user;

    // const db = getFirestore();
    await setDoc(doc(collection(db, 'users'), user.uid), {
      userId: user.uid,
      imel: email.value,
      created: serverTimestamp(),
      dateInscription: serverTimestamp(),
      lastLogin: serverTimestamp(),
      non: non.value,
      siyati: siyati.value,
      photoURL: '', // Ajout de la photo
      subscribedToAnnLi: false,
      notYet: true,
      translator: false,
      writer: false,
      admin: false,
      demandeResiliation: false,
      resiliationReasonWhy: false,
      credit: 5,
      allValidCorrections: 0,
      forLevelUser: 0,
      subscribedToWriters: [],
      usersSubscribedToMe: [],
      newUser: true,
      demandeSubscription: false,
      understoodValidation: false,
      understoodRead: false,
      understoodClassification: false,
      firstWinner: false,
      secondWinner: false,
      thirdWinner: false,
      nonValid: false,
      siyatiValid: false,
      imelValid: false,
      updateApp: true,
      updateAppMobile: false,
      authorizedCamera: false,
      prime: false,
      fb:'',
      tk: '',
      x: '',
      yt: '',
      ig: '',
      shareEmailToReaders: 'non',
      isOnline: true,
      notificationAccepted: false,
      country: '',
      age: '',
      cible: '+18',
      shareLibrary: false,
      socialMedia: false,
      isAddedToList: false,
    });
    // Réinitialisation du formulaire et fermeture du dialogue
    registrationMessage.value = "";
    signWithEmail.value = false;
    internalDialog.value = false;
    router.push('/HomePage');
    signWithEmail.value = false;
    internalDialog.value = false;
  } catch (error) {
    switch (error.code) {
      case "auth/invalid-email":
        registrationMessage.value = "Imel ou pa bon/ okenn chan pa ka vid";
        break;
      case "auth/email-already-in-use":
        registrationMessage.value = "Imel sa a deja gen kont ki kreye.";
        break;
      case "auth/weak-password":
        registrationMessage.value = "Modpas la twò fèb.";
        break;
      default:
        registrationMessage.value = "Yon erè rive pandan enskripsyon an.";
        break;
    }
  }
};
// Navigation vers d'autres pages
const navigateTo = (route) => {
  signWithEmail.value = false;
  internalDialog.value = false; // Ferme le v-dialog
  router.push(route);
};
</script>

<style scoped>
.text-amber-darken-4 {
  margin-bottom: 20px;
  margin-left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  text-decoration: none;
}

.text-grey {
  color: grey;
}

.btn-amber-darken-4 {
  background-color: yellow;
  color: black;
}

.btn-grey {
  background-color: grey;
  color: white;
}
</style>
